import Button, { BUTTON_HEIGHT_32 } from '../../../../Button'
import { DocFlowProfileHeaderInfoItemsFields } from '../../../DocFlow.constants'

import LinkIcon from '../../../../../icons/link-1.svg'
import RefreshIcon from '../../../../../icons/refresh.svg'

export const DOC_FLOW_PROFILE_HEADER_INFO_ITEM_ACTION_QA_NAMES = {
  [DocFlowProfileHeaderInfoItemsFields.BuildingGroups]: {
    add: 'docFlowProfileHeaderBuildingGroupsAddBtn',
    edit: 'docFlowProfileHeaderBuildingGroupsEditBtn',
  },
  [DocFlowProfileHeaderInfoItemsFields.Buildings]: {
    add: 'docFlowProfileHeaderBuildingsAddBtn',
    edit: 'docFlowProfileHeaderBuildingsEditBtn',
  },
}

export const DOC_FLOW_PROFILE_HEADER_INFO_ITEM_UK_CREDITS_ACTIONS_KEY =
  'refresh_balance'

export const DOC_FLOW_PROFILE_HEADER_INFO_ITEM_CONNECTED_REQUESTS_ACTIONS_KEY =
  'connect_requests'

export const DOC_FLOW_PROFILE_HEADER_INFO_ITEM_CONNECTED_REQUESTS_ACTIONS = [
  {
    Button: Button.Outlined,
    key: DOC_FLOW_PROFILE_HEADER_INFO_ITEM_CONNECTED_REQUESTS_ACTIONS_KEY,
    props: {
      beforeIconProps: { Icon: LinkIcon },
      height: BUTTON_HEIGHT_32,
      qaName: 'docFlowProfileHeaderConnectRequestsBtn',
      tooltip: 'DocFlow.ProfileInfoItemConnectRequestsBtnTooltipKey',
    },
    show: () => true,
  },
]

export const DOC_FLOW_PROFILE_HEADER_INFO_ITEM_UK_CREDITS_ACTIONS = [
  {
    key: DOC_FLOW_PROFILE_HEADER_INFO_ITEM_UK_CREDITS_ACTIONS_KEY,
    props: {
      beforeIconProps: { Icon: RefreshIcon },
      height: BUTTON_HEIGHT_32,
      tooltip: 'DocFlow.ProfileInfoItemRefreshBalanceBtnTooltipKey',
    },
    show: () => true,
  },
]
